export default __webpack_public_path__ + "static/7-c2c41d19d3f9d1607280e3bc1a51bc6d.png";